//login.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase";
import { useAuth } from "../../contexts/AuthContext";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const { resetPassword } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [error, setError] = useState(null);
  
  // Password reset modal state
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetMessage, setResetMessage] = useState("");
  const [resetError, setResetError] = useState("");

  // Handle form input changes
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle email/password sign in
  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    setIsAuthenticating(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      navigate("/dashboard");
    } catch (error) {

      setError("Invalid email or password. Please try again.");
    } finally {
      setIsAuthenticating(false);
    }
  };

  // Function to handle the password reset process
  const handlePasswordReset = async (e) => {
    e.preventDefault();
    try {
      setResetMessage("");
      setResetError("");
      setIsAuthenticating(true);
      await resetPassword(resetEmail);
      setResetMessage("Check your inbox for further instructions.");
    } catch (error) {
      setResetError("Failed to reset password. Please check the email address.");
    }
    setIsAuthenticating(false);
  };
  
  // Function to open the modal
  const openResetModal = (e) => {
    e.preventDefault(); // Prevent the link from navigating
    setIsResetModalOpen(true);
    // Clear any previous messages
    setResetEmail("");
    setResetMessage("");
    setResetError("");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src="/You_Create_Logo_WEB.png"
            alt="YouCreate Logo"
            className="login-logo"
          />
          <h2>Welcome back!</h2>
          <br></br>
          <p>Please sign in to continue</p>
        </div>

        <form onSubmit={handleEmailSignIn} className="login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="login-input"
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleInputChange}
              required
              className="login-input"
            />
          </div>

          <div className="forgot-password">
            <a href="#" onClick={openResetModal} className="forgot-link">
              Forgot your password?
            </a>
          </div>

          <button
            type="submit"
            disabled={isAuthenticating}
            className="signin-button"
          >
            {isAuthenticating ? "Signing In..." : "Sign In"}
          </button>

          <div className="signup-link">
            <span>Don't have an account?</span>
            <br></br>
            <Link to="https://youcreate.app/#pricing">See our offers here</Link>
          </div>
        </form>
      </div>

      {/* Password Reset Modal */}
      {isResetModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Reset Password</h3>
            {resetError && <div className="error-message" style={{marginBottom: '1rem'}}>{resetError}</div>}
            {resetMessage && <div className="success-message" style={{marginBottom: '1rem'}}>{resetMessage}</div>}
            <form onSubmit={handlePasswordReset}>
              <div className="input-group">
                <label htmlFor="reset-email">Enter your email address</label>
                <input
                  id="reset-email"
                  type="email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  required
                  className="login-input"
                  style={{ marginTop: '0.5rem' }}
                />
              </div>
              <div className="modal-buttons" style={{ marginTop: '1.5rem' }}>
                <button type="submit" disabled={isAuthenticating} className="signin-button">
                  Send Reset Email
                </button>
                <button 
                  type="button" 
                  onClick={() => setIsResetModalOpen(false)}
                  className="cancel-button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
